import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA7gVL1ZZgXmqNHOneAR9TOZJYxH0RMDMc",
  authDomain: "bagioffice.firebaseapp.com",
  projectId: "bagioffice",
  storageBucket: "bagioffice.appspot.com",
  messagingSenderId: "485853906934",
  appId: "1:485853906934:web:7c85fd696875515b0669d7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
